(ns app.front.view.group.admin.form-schemas.form-attr-editors
  (:require [app.domain.form.form-editor-util :as form-editor-util]
            [app.domain.form.i18n :as form-i18n]
            [app.domain.form.schema :as form-schema]
            [app.front.ui :as ui]
            [app.front.ui.i18n :as ui-i18n]
            [app.front.ui.multi-select :as ui-ms]
            [app.front.ui.select :as ui-select]
            [app.front.ui.table :as ui-table]
            [app.front.util :refer [for-frag for-frag-indexed] :as futil]
            [app.front.view.group.admin.form-schemas.subs :as form-schemas-subs]
            [app.front.view.group.admin.form-schemas.util :as form-schemas-util]
            [app.front.view.group.admin.subs :as gas]
            [app.i18n.model :as i18n-model]
            [clojure.string :as str]
            [core.front.carbon :as cc]
            [core.front.event :refer [<sub >evt]]
            [core.front.icons :as i]
            [core.util.normalize :as normalize]
            [core.util.string :as str-util]
            [core.util.util :as util]
            [goog.string.format]
            [potpuri.core :as p]
            [re-frame.core-instrumented :as rf]
            [reagent.core :as r]))

(defn attr->label [tr attr]
  (tr [(keyword "form.schema" (name attr))]))


(defn button-to-show-or-hide-values [{:keys [label disabled on-click icon]}]
  (cc/button
    {:icon-position :right
     :size          :small
     :icon          (or icon i/plus)
     :kind          :tertiary
     :disabled      disabled
     :class-name    "mr-2 mt-1"
     :on-click      on-click}
    label))


(defn editor-for-coll-of-str-attr [attr
                                   {:keys [tr]}
                                   {:keys [attributes id] :as form-element}
                                   {:keys [header-label item-label required?]}]
  (r/with-let [step                   10
               *options-to-show-count (r/atom step)]
    (let [values      (get attributes attr)
          max-options (count values)]
      [:<>
       [:div.flex.mt-1.items-center
        {:class (when required? "required-field")}
        [:div.ml-1 (str header-label ":")]
        [:div.ml-1.mr-1.font-bold (str max-options)]
        (form-schemas-util/only-icon-button
          {:icon             i/plus
           :icon-description (tr [:form.schema/add-option])
           :on-click         #(>evt [::form-schemas-subs/edit-val-in-tuple-attr
                                     form-element
                                     {:value "" :index max-options :attr attr}])})]
       (when (seq values)
         [:div.mt-1.rounded
          {:class "border-ui-black border-solid border-2"}
          (when (> max-options step)
            [:div.mt-1.ml-1.mb-1
             [button-to-show-or-hide-values {:label    (tr [:form.schema/show-more])
                                             :disabled (= @*options-to-show-count max-options)
                                             :on-click (fn [_] (swap! *options-to-show-count
                                                                      #(min (+ step %) max-options)))}]

             [button-to-show-or-hide-values {:label    (tr [:form.schema/show-less])
                                             :disabled (= @*options-to-show-count 0)
                                             :icon     i/minus
                                             :on-click (fn [_] (swap! *options-to-show-count
                                                                      #(max (- % step) 0)))}]
             (if (= @*options-to-show-count max-options)

               [button-to-show-or-hide-values {:label    (tr [:form.schema/hide-all])
                                               :disabled false
                                               :icon     i/minus
                                               :on-click (fn [_] (reset! *options-to-show-count 0))}]
               [button-to-show-or-hide-values {:label    (tr [:form.schema/show-all])
                                               :disabled false
                                               :on-click (fn [_] (reset! *options-to-show-count max-options))}])])
          (for-frag-indexed [[i value] (take @*options-to-show-count values)]
            [:div.flex.items-center.mb-3.mt-2.ml-2
             [ui/text-input {:value      value
                             :label-text (str (inc i) ". " item-label)
                             :on-change  #(rf/dispatch-sync [::form-schemas-subs/edit-val-in-tuple-attr
                                                             form-element
                                                             {:index i :value (futil/tval %) :attr attr}])}]
             (form-schemas-util/only-icon-button
               {:icon             i/remove
                :id               (str id "-" attr "-" i "remove")
                :on-click         (fn [_] (>evt [::form-schemas-subs/edit-val-in-tuple-attr
                                                 form-element
                                                 {:index i :value nil :attr attr}]))
                :icon-description (tr [:edit])
                :class-name       "only-icon-button mt-4"
                :disabled         (>= 1 max-options)})])])])))


(defn default-on-change [path updates]
  (>evt [::form-schemas-subs/edit-attrs-of-form-el path updates]))

(defn text-input-props [{:keys [attr tr id attributes path props]}]
  (merge {:id         (str id "-" (name attr))
          :value      (get attributes attr)
          :label-text (attr->label tr attr)
          :on-change  #(rf/dispatch-sync [::form-schemas-subs/edit-attrs-of-form-el path {attr (futil/tval %)}])}
         (update props :required boolean)))

(defn editor-for-long-str-type-attr [attr {:keys [tr]} {:keys [id attributes path]} & [props]]
  [ui/text-area (text-input-props (util/mmap attr tr id attributes path props))])

(defn editor-for-str-type-attr [attr {:keys [tr]} {:keys [id attributes path]} & [props]]
  [ui/text-input (text-input-props (util/mmap attr tr id attributes path props))])

(defn editor-for-localized-str-type-attr [attr {:keys [tr]} {:keys [id attributes path]} & [_props]]
  ;; TODO: We could show the placeholder list component here
  (let [defaults    (<sub [::form-schemas-subs/translation-entries-for-key attr])
        current-val (get attributes attr)]
    [ui-i18n/localized-string-edit
     {:id                  (str id "-" (name attr))
      :label-text          (attr->label tr attr)
      :strings             (merge
                             ;; Show the dictionary values as defaults (if applicable)
                             defaults
                             (if (string? current-val)
                               {i18n-model/default-lang current-val}
                               current-val))
      :allowed-locales-sub form-schemas-util/locales-sub
      :multiline?          (form-i18n/localized-attrs-with-long-text attr)
      :on-change           (fn [args]
                             (let [m (->> args
                                          ;; If the user clears the text, set it to nil. This reverts it
                                          ;; to the default value in the dictionary
                                          (remove (comp str/blank? second))
                                          ;; Don't store text if it matches the default
                                          (remove (fn [[k v]] (= (get defaults k) v)))
                                          (into {}))]
                               (rf/dispatch-sync [::form-schemas-subs/edit-attrs-of-form-el path {attr m}])))}]))

(defn editor-for-disabled-attr [attr ctx form-el & [props]]
  (editor-for-str-type-attr attr ctx form-el (merge props {:disabled true})))


(defn- editor-for-number-type-attr [attr {:keys [tr]} {:keys [id attributes path]} & [props]]
  [ui/number-input
   (merge {:id         (str id "-" (name attr))
           :value      (get attributes attr)
           :on-change  #(default-on-change path {attr (-> % futil/tval futil/parse-float)})
           :label-text (attr->label tr attr)}
          props)])


(defn editor-for-boolean-type-attr [attr {:keys [tr on-toggle-function]} {:keys [id attributes path]} & [props]]
  (cc/toggle
    (merge {:id         (str id "-" (name attr))
            :labelA     (tr [:false])
            :labelB     (tr [:true])
            :label-text (attr->label tr attr)
            :toggled    (-> (get attributes attr) boolean)
            :on-toggle  (if (nil? on-toggle-function)
                          #(default-on-change path {attr %})
                          on-toggle-function)}
           props)))


(defn editor-for-options-type-attr [attr {:keys [tr]} {:keys [id attributes path]} {:keys [values] :as props}]
  (let [curr-val (get attributes attr)]
    [ui-select/select
     (merge {:id           (str id "-" (name attr))
             :label-text   (tr [(keyword "form.schema" attr)])
             :value        curr-val
             :allow-empty? true
             :class-name   "full-width-select"
             :select-text  (tr [:form.schema/none])
             :val->str     #(if (keyword? %)
                              (tr [(keyword "form.schema" %)])
                              (str %))
             :on-change    #(default-on-change path {attr %})}
            props
            {:values (-> (if curr-val [curr-val] [])
                         (into values)
                         distinct)})]))


(defn editor-for-integration-id
  [attr {:keys [tr enabled-subscription]} {:keys [id attributes path]} & [props]]
  (when (and enabled-subscription (<sub enabled-subscription))
    [ui/text-input (merge (text-input-props (util/mmap attr tr id attributes path props))
                          {:on-change (fn [e]
                                        (let [v (-> e futil/tval str-util/blank->nil)]
                                          (rf/dispatch-sync
                                            [::form-schemas-subs/edit-attrs-of-form-el path {attr v}])))})]))


(defmulti ^{:arglist '([attr ctx form-element])} editor-for-attr (fn [attr _ _] attr))

(defmethod editor-for-attr :default [attr ctx form-el]
  (if (form-i18n/localized? attr)
    [editor-for-localized-str-type-attr attr ctx form-el]
    [:span
     (str "No editor defined for attribute '" attr "'!")]))

(defmethod editor-for-attr :placeholder [attr ctx form-el] [editor-for-str-type-attr attr ctx form-el])
(defmethod editor-for-attr :text [attr ctx form-el] [editor-for-long-str-type-attr attr ctx form-el {:required true}])

(defmethod editor-for-attr :step [attr ctx {:keys [path] :as form-el}]
  (let [step->decimals-allowed? (fnil (complement int?) 1)
        form-el                 (update-in form-el [:attributes attr] step->decimals-allowed?)
        props                   {:on-toggle (fn [enabled?]
                                              (default-on-change path {attr (if enabled? 0.1 1)}))}]
    [editor-for-boolean-type-attr attr ctx form-el props]))

(defmethod editor-for-attr :form.field/required [attr ctx form-el] [editor-for-boolean-type-attr attr ctx form-el])
(defmethod editor-for-attr :phrases-picker? [attr {:keys [tr] :as ctx} {{:keys [phrases-picker?]} :attributes :keys [type path] :as form-el}]
  (when (or phrases-picker? (not= type :input))
    [:div.flex
     [editor-for-boolean-type-attr
      attr
      (assoc
        ctx
        :on-toggle-function
        #(do
           (default-on-change path {attr %})
           (when (true? %)
             (default-on-change path {:rich-text? %}))))
      form-el]

     (when phrases-picker?
       [ui/help (tr [:form.schema/phrases-picker-help])])]))

(defmethod editor-for-attr :rich-text? [attr ctx  {{:keys [phrases-picker?]} :attributes :as form-el}]
  [editor-for-boolean-type-attr attr ctx form-el {:disabled (boolean phrases-picker?)}])

(defmethod editor-for-attr :id [attr ctx form-el] [editor-for-disabled-attr attr ctx form-el])
(defmethod editor-for-attr :signature-type [attr ctx form-el] [editor-for-disabled-attr attr ctx form-el])
(defmethod editor-for-attr :sign-off [attr ctx form-el] [editor-for-disabled-attr attr ctx form-el])
(defmethod editor-for-attr :show-download-form? [attr ctx form-el] [editor-for-boolean-type-attr attr ctx form-el])
(defmethod editor-for-attr :type [attr ctx form-el] [editor-for-disabled-attr attr ctx form-el])

(defmethod editor-for-attr :form.field/integration-field-id [attr ctx form-el]
  [editor-for-integration-id
   attr
   (assoc ctx :enabled-subscription [::gas/has-feature? :group.feature/backend-system-integration])
   form-el])

(defmethod editor-for-attr :form.field/ecm-integration-field-id [attr ctx form-el]
  [editor-for-integration-id
   attr
   (assoc ctx :enabled-subscription [::gas/ecm-integration-enabled?])
   form-el])

(defmethod editor-for-attr :label [attr {:keys [tr] :as ctx} {:keys [type] :as form-el}]
  ;; Use own label for sections
  [editor-for-str-type-attr attr ctx form-el (merge {:required true}
                                                    (when (= type :section)
                                                      {:label-text (tr [:form.schema/section-label])}))])


(defmethod editor-for-attr :field [attr ctx form-el] [editor-for-disabled-attr attr ctx form-el {:required true}])


(defn validate-field-key [path field-key authority-group-id]
  (when field-key
    (>evt [::form-schemas-subs/validate-field-key path field-key authority-group-id])
    (>evt [::form-schemas-subs/validate-field-key-locally path field-key])))


(defn on-description-change [attr {:keys [type path]} val]
  (let [new-value (futil/tval val)
        kw-value  (normalize/keyword-from-name new-value)]
    (default-on-change path
                       (merge {attr   new-value
                               :field kw-value}
                              ;; id attr is only used for rendering on actual forms
                              (when (and kw-value
                                         (->> (form-schemas-util/config-for-types type)
                                              :editable-attrs
                                              (some #{:id})))
                                {:id (-> kw-value
                                         name
                                         (str "-id"))})))))


(defmethod editor-for-attr :description [attr {:keys [tr authority-group-id] :as ctx} {:keys [attributes path type] :as form-el}]
  (let [on-change       (partial on-description-change attr form-el)
        value           (get attributes attr)
        conflict        (-> form-el :conflicting-field)
        ;; same :field in use?
        local-duplicate (-> form-el :locally-conflicting-field)
        ;; same :field in use for an element of different type?
        local-conflict  (and local-duplicate
                             (not= type (:type local-duplicate)))
        too-long?       (form-schemas-util/field-key-max-length-exceeded? value)
        invalid?        (or (some? conflict)
                            local-conflict
                            too-long?)]
    [:<>
     [editor-for-str-type-attr attr
      ctx
      form-el
      {:required     true
       :value        value
       :invalid      (or invalid? local-conflict)
       :invalid-text (cond
                       conflict
                       (tr [:form.schema/conflicting-field-key])

                       local-conflict
                       (tr [:form.schema/conflicting-local-field-key-err])

                       too-long?
                       (tr [:form.schema/description-max-length-err] [form-schemas-util/field-key-max-length]))
       :on-change    on-change
       :on-blur      #(validate-field-key path (normalize/keyword-from-name value) authority-group-id)
       :helper-text  (tr [:form.schema/description-help])}]
     (when (and local-duplicate
                (not local-conflict))
       [:div.bx--form__helper-text (tr [:form.schema/conflicting-local-field-key-warn])])]))


(defmethod editor-for-attr :value [attr ctx {:keys [new-field?] :as form-el}]
  [editor-for-str-type-attr attr ctx form-el {:disabled (not new-field?)}])


(defmethod editor-for-attr :unit [attr ctx {:keys [path] :as form-el}]
  (let [unit-map (<sub [::form-schemas-subs/attr-unit-choices])]
    [editor-for-options-type-attr
     attr
     ctx
     form-el
     {:values    (keys unit-map)
      :val->str  (fn [k]
                   (let [label (get-in unit-map [k :label])]
                     (if (str/blank? label)
                       (name k)
                       label)))
      :on-change #(default-on-change path {attr % :unit-label nil})}]))


(defmethod editor-for-attr :unit-label [attr ctx {:keys [path] :as form-el}]
  [editor-for-options-type-attr
   attr
   ctx
   form-el
   {:values    form-schema/new-values-for-unit-label
    :on-change #(default-on-change path {:unit-label % :unit nil})}])


(defmethod editor-for-attr :form.field/validator [attr ctx {:keys [type] :as form-el}]
  [editor-for-options-type-attr attr
   ctx
   form-el
   (->> (case type
          :number-input [:positive-integer
                         :non-negative-integer
                         :integer
                         :positive-number
                         :non-negative-number]
          :input [:CA-postal-code]
          [])
        (hash-map :values))])


(defmethod editor-for-attr :headers [attr {:keys [tr] :as ctx} {:keys [type] :as form-el}]
  (let [table? (= type :table)]
    [editor-for-coll-of-str-attr attr ctx form-el
     {:header-label (tr [(if table?
                           :form.schema/table-headers
                           :form.schema/headers-for-form-element)])
      :item-label   (tr [:form.schema/header-item])
      :required?    table?}]))


(defmethod editor-for-attr :form.field/valid-values [attr {:keys [tr] :as ctx} form-el]
  [editor-for-coll-of-str-attr attr ctx form-el {:header-label (tr [:form.schema/valid-values-for-dropdown])
                                                 :item-label   (tr [:form.schema/valid-value-item])}])

;; TODO for :select - disabled for now, just keep it true by default
(defmethod editor-for-attr :no-tr? [attr ctx form-el]
  [editor-for-boolean-type-attr attr ctx form-el])


(def default-value-attributes
  "Static attributes that can be resolved to a default value"
  #{[:property/zoning]
    [:workspace/structural-address]})


(defn default-value->state
  [current-value type]
  (cond
    (and (string? current-value)
         (#{:select :radio-button-group} type))
    {:source :form.schema/default-value-choice
     :value  current-value}

    (string? current-value)
    {:source :form.schema/default-value-string
     :value  current-value}

    (default-value-attributes current-value)
    {:source :form.schema/default-value-workspace-attribute
     :value  current-value}

    (= :party (first current-value))
    {:source :form.schema/default-value-party-licence
     :value  (:user-licence/type (last current-value))}

    :else
    {:source :form.schema/default-value-no}))


(defn state->default-value
  [{:keys [source value]}]
  (case source
    :form.schema/default-value-no nil
    :form.schema/default-value-string value
    :form.schema/default-value-choice value
    :form.schema/default-value-workspace-attribute value
    :form.schema/default-value-party-licence [:party :party/user :user/licences {:user-licence/type value}]))


(defmulti edit-default-value (fn [{:keys [source]} _ _ _] source))


(defmethod editor-for-attr :default-value-source
  [attr {:keys [tr]} {:keys [attributes path type] :as form-el}]
  (let [{:keys [source] :as state} (default-value->state (get attributes attr) type)
        initial-values             (<sub [::form-schemas-subs/init-values-for-default-value form-el])
        available-sources          (<sub [::form-schemas-subs/available-default-value-sources type])
        on-source-change           (fn [source]
                                     (default-on-change path {attr (-> {:source source
                                                                        :value  (initial-values source)}
                                                                       state->default-value)}))
        on-value-change            (fn [value]
                                     (default-on-change path {attr (-> (assoc state :value value)
                                                                       state->default-value)}))]
    [:<>
     [ui-select/select
      {:id           "default-value-source-select"
       :label-text   (tr [:form.schema/default-value-source-dropdown])
       :value        source
       :allow-empty? false
       :class-name   "full-width-select"
       :val->str     (fn [k] (tr [k]))
       :on-change    on-source-change
       :values       available-sources}]
     (when-not (= :form.schema/default-value-no source)
       [:div.mt-3
        [edit-default-value state tr on-value-change form-el]])]))


(defmethod edit-default-value :form.schema/default-value-string
  [{:keys [value]} tr on-change _]
  (let [on-change (comp on-change futil/tval)]
    [ui/text-input
     {:id         "default-value-string-input"
      :value      value
      :label-text (tr [:form.schema/default-value])
      :on-change  on-change}]))


(defmethod edit-default-value :form.schema/default-value-choice
  [{:keys [value]} tr on-change form-el]
  (let [choices (form-editor-util/form-el->child-values form-el)]
    [ui-select/select
     {:id           "default-value-choice-select"
      :label-text   (tr [:form.schema/default-value])
      :value        value
      :allow-empty? false
      :class-name   "full-width-select"
      :val->str     identity
      :on-change    on-change
      :values       choices}]))


(defmethod edit-default-value :form.schema/default-value-workspace-attribute
  [{:keys [value]} tr on-change _]
  [ui-select/select
   {:id           "default-value-attribute-select"
    :label-text   (tr [:form.schema/default-value])
    :value        value
    :allow-empty? false
    :class-name   "full-width-select"
    :val->str     tr
    :on-change    on-change
    :values       default-value-attributes}])


(defmethod edit-default-value :form.schema/default-value-party-licence
  [{:keys [value]} tr on-change _]
  (let [choices (<sub [::form-schemas-subs/default-licence-choices])]
    [ui-select/select
     {:id           "default-value-licence-select"
      :label-text   (tr [:form.schema/default-value])
      :value        value
      :allow-empty? false
      :class-name   "full-width-select"
      :val->str     (fn [k] (tr [k]))
      :on-change    on-change
      :values       choices}]))


(def class-name-values ["bottom-aligned-form-items"])


(defmethod editor-for-attr :class-name [attr ctx form-el]
  [editor-for-options-type-attr attr ctx form-el {:values class-name-values}])


(defmethod editor-for-attr :number-of-columns [attr {:keys [tr] :as ctx} form-el]
  [editor-for-number-type-attr attr ctx form-el {:invalid      (some-> (get-in form-el [:attributes attr])
                                                                       pos-int?
                                                                       not)
                                                 :invalid-text (tr [:form.schema/value-must-be-positive-integer])}])


(defn add-condition [{:keys [tr]}
                     {:keys [attributes id path]}
                     {:keys [condition-type extracted-keys]}]
  (when-some [available-fields (-> (<sub [::form-schemas-subs/available-fields attributes extracted-keys])
                                   seq)]
    (r/with-let [*editing?    (r/atom false)
                 *field-data  (r/atom {})]
      [:div.mt-6
       (if-not @*editing?
         (cc/button
           {:kind             :tertiary
            :icon             i/plus
            :icon-description (tr [:form.schema/add-condition])
            :on-click         #(reset! *editing? true)}
           (tr [:form.schema/add-condition]))

         (let [selected-field      (get @*field-data :new-cond-field "")
               selected-value      (get @*field-data :new-cond-value "")
               vals-for-cond-field (<sub [::form-schemas-subs/vals-for-field selected-field])]

           (when-not (= condition-type :SINGLE)
             (swap! *field-data assoc :cond-type condition-type))

           [:<>
            (when (= condition-type :SINGLE)
              [:<>
               [:div.flex.required-field.mb-3.text
                (tr [:form.schema/choose-condition])]
               [:div.flex.mb-3.gap-x-2.pr-3
                (into
                  [ui/select-pills {:on-change    #(swap! *field-data assoc :cond-type %)
                                    :value        (:cond-type @*field-data "")
                                    :class        "pb-6 pr-6"
                                    :option-class "uppercase"}]
                  (for [cnd [:AND :OR]]
                    {:value cnd
                     :text  (if (= cnd :AND)
                              (tr [:form.schema/and])
                              (tr [:form.schema/or]))}))]])

            [:div.flex.mt-3
             [:div.w-1-2
              [ui-select/select
               {:id         (str id "-cond-key-condition")
                :label-text (tr [:form.schema/condition-field-key])
                :required   true
                :value      selected-field
                :class-name "full-width-select"
                :val->str   #(some-> % str (subs 1))
                :on-change  #(swap! *field-data assoc :new-cond-field %)
                :values     available-fields}]]
             [:div.w-1-2
              [ui-select/select
               {:id         (str id "-cond-key-condition")
                :label-text (tr [:form.schema/condition-field-value])
                :required   (boolean selected-field)
                :value      selected-value
                :class-name "full-width-select ml-1"
                :val->str   str
                :on-change  #(swap! *field-data assoc :new-cond-value %)
                :values     vals-for-cond-field}]]]

            [:div.bx--row.mt-3.justify-end
             [:div.flex.gap-x-2.pr-3
              (cc/button
                {:kind     :tertiary
                 :on-click (fn [_]
                             (reset! *editing? false)
                             (reset! *field-data {}))}
                (tr [:cancel]))
              (cc/button
                {:kind             :primary
                 :icon             i/save
                 :icon-description (tr [:form.schema/add-condition])
                 :disabled         (-> (let [required-keys [:new-cond-field :new-cond-value]
                                             values        (-> (select-keys @*field-data required-keys) vals)
                                             cond-type     (:cond-type @*field-data)]
                                         (or (some str/blank? values)
                                             (not-every? #(contains? @*field-data %) required-keys)
                                             (= cond-type :SINGLE)
                                             (str/blank? cond-type)))
                                       boolean)
                 :on-click         (fn [_]
                                     (>evt [::form-schemas-subs/save-condition
                                            (assoc @*field-data
                                                   :path path
                                                   :condition-type condition-type)])
                                     (reset! *editing? false)
                                     (reset! *field-data {}))}
                (tr [:form.schema/save-condition]))]]]))])))

(defmethod editor-for-attr :condition [_ {:keys [tr]
                                          :as   ctx}
                                       {:keys [attributes path]
                                        :as   form-element}]
  (let [{:keys [condition-type extracted-fields]
         :as   group-condition}                  (form-schemas-util/group-condition (:condition attributes))]
    (if (= :complex condition-type)
      [:div
       (tr [:form.schema/complex-schema-not-supported])]
      [:<>
       (when (seq extracted-fields)
         [:div
          [:div.mb-4.flex
           [:div (tr [:form.schema/condition-type])]
           [:div.ml-4 condition-type]]
          [ui-table/modern-responsive-table
           {:items              extracted-fields
            :tr                 tr
            :id-func            #(rand-int 1001)
            :row-class-override "lg:items-center hover:bg-ui-blue-10"
            :cols               [["Field" keys]
                                 ["Value" (comp str first vals)]]
            :make-actions       (fn [p]
                                  [{:icon            i/trash
                                    :title           (tr [:form.schema/delete-condition])
                                    :on-click        #(>evt [::form-schemas-subs/delete-condition {:path  path
                                                                                                   :field (-> p keys first)}])
                                    :confirm?        true
                                    :confirm-content (tr [:form.schema/delete-condition-confirm])}])}]])
       [:div
        [add-condition ctx form-element group-condition]]])))

(defmethod editor-for-attr :required-role [attr {:keys [tr]} {:keys [attributes id path]}]
  (let [curr-selection (->> (get attributes attr)
                            (p/wrap-into []))
        party-roles    (<sub [::form-schemas-subs/available-party-roles])]
    [ui-ms/multi-select
     {:id           (str id "-role-select")
      :label-text   (tr [:form.schema/required-role])
      :value        curr-selection
      :allow-empty? true
      :val->str     #(-> party-roles (p/find-first {:role-key %}) :label)
      :on-change    #(default-on-change path {attr (vec %)})
      :values       (map :role-key party-roles)}]))

(defn- show-language-selector?
  [type]
  (boolean (some form-i18n/localized?
                 (-> type
                     form-schemas-util/editable-attrs-for-type))))

(defn- language-selector
  []
  [:div.mt-3
   [ui-i18n/edit-language-selector {:allowed-locales-sub form-schemas-util/locales-sub}]])

(defn- can-edit-units?
  "Allow editing the unit (and unit-label) if both were accidentally left empty"
  [{:keys [existing-field] :as form-element} attr]
  (let [units #{:unit :unit-label}]
    (-> (and
          (nil? existing-field) ; Always forbid if data was sourced from an external field
          (units attr)
          (not (form-schemas-util/attributes-defined? form-element units)))
        boolean)))

(defn- can-edit?
  [{:keys [new-field? existing-field] :as form-element} attr]
  (let [new-attr?             (and new-field? (nil? existing-field))
        attr-can-be-modified? (not (form-schemas-util/disabled-attrs-for-existing-form-field attr))
        units-not-defined?    (can-edit-units? form-element attr)]
    (or new-attr?
        attr-can-be-modified?
        units-not-defined?)))

(defn attr-editors-for-form-el [ctx {:keys [type] :as form-element}]
  [:<>
   (when (show-language-selector? type)
     [language-selector])
   (for-frag [attr (form-schemas-util/editable-attrs-for-type type)]
     [:div.mt-3
      (if (can-edit? form-element attr)
        [editor-for-attr attr ctx form-element]
        [editor-for-disabled-attr attr ctx form-element])])])
